/* eslint-disable import/prefer-default-export */
import { trackEvent } from 'user-analytics';
import { hashPurchaseToken, PURCHASE_TOKEN_HASH } from 'utils/analyticsPseudonym';

/** Track customer intent only; economic outcomes are emitted by Purchase. */
export function trackCdsPoints(event, token, points) {
  trackEvent(event, { [PURCHASE_TOKEN_HASH]: hashPurchaseToken(token), points_amount: points });
}
